import { useForm } from "react-hook-form";
import DialogComponent from "../../dialog-component/dialog-component";
import TextInputFormField from "../../form-fields/text-input-field/text-input-form-field";
import { InviteUserModalProps } from "./types";
import {
  ModalBaseForm,
  ModalButtonsContainer,
} from "../../dialog-component/dialog-component.styles";
import { PrimaryButton } from "../../button/button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch } from "../../../store/hooks";
import { useState } from "react";
import { addNotification } from "../../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { inviteUserFormValidation } from "../../../utils/validations";
import { inviteUser } from "../../../actions";

const ModalBody: React.FC<InviteUserModalProps> = ({ onClose }) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { control, watch } = useForm({
    mode: "all",
    resolver: yupResolver(inviteUserFormValidation()),
  });

  const handleSubmit = () => {
    setIsLoading(true);
    inviteUser({ ...watch() })
      .then((response: any) => {
        const { message }: { message: string } = response.data;
        onClose && onClose();
        dispatch(
          addNotification({
            id: uuid(),
            type: "success",
            message: message,
          })
        );
      })
      .catch((error) => {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: error.response?.data?.message || error.message,
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <ModalBaseForm>
      <TextInputFormField
        name="name"
        control={control}
        label="Name"
        placeholder="Enter here"
      />
      <TextInputFormField
        name="email"
        control={control}
        label="Email"
        placeholder="Enter here"
      />
      <ModalButtonsContainer onClick={handleSubmit}>
        <PrimaryButton isLoading={isLoading}>Invite</PrimaryButton>
      </ModalButtonsContainer>
    </ModalBaseForm>
  );
};

const InviteUserModal: React.FC<InviteUserModalProps> = ({ open, onClose }) => {
  return (
    <DialogComponent
      title="Invite User"
      content={<ModalBody onClose={onClose} open={open} />}
      open={open}
      onClose={onClose}
    />
  );
};

export default InviteUserModal;
